import React from "react";
import { permissionGroups } from "../../config/menuConfig";
import MultiSelectField from "./MultiSelectField";
import { useTranslation } from "../../i18n/I18nContext";

// One MultiSelectField per menu group (Funcionários, Turmas, ...), each with a
// "seleccionar tudo / limpar" shortcut — the UI for picking which menu items
// (permissions) a Profile (role) grants.
const PermissionGroupsField = ({ selectedCodes = [], onChange }) => {
  const { t } = useTranslation();

  const toggleGroup = (group) => {
    const groupCodes = group.items.map((i) => i.code);
    const allSelected = groupCodes.every((code) => selectedCodes.includes(code));
    if (allSelected) {
      onChange(selectedCodes.filter((code) => !groupCodes.includes(code)));
    } else {
      onChange(Array.from(new Set([...selectedCodes, ...groupCodes])));
    }
  };

  return (
    <div className='d-flex flex-column gap-16'>
      {permissionGroups.map((group) => {
        const groupCodes = group.items.map((i) => i.code);
        const allSelected = groupCodes.every((code) => selectedCodes.includes(code));
        return (
          <div key={group.key}>
            <div className='d-flex align-items-center justify-content-between mb-8'>
              <label className='form-label mb-0'>{t(group.label)}</label>
              <button
                type='button'
                className='btn btn-sm btn-outline-secondary py-4 px-12'
                onClick={() => toggleGroup(group)}
              >
                {allSelected ? t("perfis.action.clearAll") : t("perfis.action.selectAll")}
              </button>
            </div>
            <MultiSelectField
              items={group.items}
              getOptionValue={(i) => i.code}
              getOptionLabel={(i) => t(i.label)}
              selectedIds={selectedCodes.filter((code) => groupCodes.includes(code))}
              onChange={(codesForGroup) =>
                onChange([...selectedCodes.filter((code) => !groupCodes.includes(code)), ...codesForGroup])
              }
              placeholder={t("perfis.field.permissions.placeholder")}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PermissionGroupsField;
